import {createSlice} from "@reduxjs/toolkit";
import {getCategoriesFetch, getFeaturedFetch} from "./searchNullFetch";

const initialState = {
    isLoading:false,
    error:'',
    productsFeatured: [],
    categories:[]

}
const SearchNullSlice = createSlice({
    name: 'searchNull',
    initialState,
    reducers:{},
    extraReducers:{
        [getFeaturedFetch.pending.type]: (state) => {
            state.isLoading = true
        },
        [getFeaturedFetch.fulfilled.type]:(state, action)=>{
            state.isLoading = false
            state.errorJobPage = ''
            state.productsFeatured = action.payload
        },
        [getFeaturedFetch.rejected.type]:(state, action)=>{
            state.isLoading = false
            state.error = action.payload
        },

        [getCategoriesFetch.pending.type]: (state) => {
            state.isLoading = true
        },
        [getCategoriesFetch.fulfilled.type]:(state, action)=>{
            state.isLoading = false
            state.errorJobPage = ''
            state.categories = action.payload
        },
        [getCategoriesFetch.rejected.type]:(state, action)=>{
            state.isLoading = false
            state.error = action.payload
        },

    }
})
export const {} = SearchNullSlice.actions

export default SearchNullSlice.reducer
